export default {
    //Messenger Bot Flow Builder States
    Flows: [],
    BotSheets: [],
    Templates: [],
    UserGrowthTools: [],
    ContactTags: [],
    UserPostBacks: [],
    MessengerBroadcast: [],
    CurrentContextMenu: [],
    AncestryRecordsMultiPage: {},
    ActivePage: {
        label: "Choose Your Page Here",
        value : "",
        page_id : "",
        access_token : "",
        logo : "",
        cover : "",
        category : "",
    },
    PageOptions: {},
    MessengerSequences: [],
    CustomVariables: [],
    OTN: [],
    PersistentMenuCache: {},
    PostbackQrMap: {},
    IsFlowReadOnly: false,
    FlowStats: {},
    RecurringCampaigns: [],
    persistentMenuItemSettingsClose: "",
    ConversionLogsItems: [],
    AdAccounts: [],
    ActiveAdAccount: null,
    ActiveCampaignColumns: [],

    //Email Flow Builder States
    Emails: [],
    EmailReports: {},
    CustomForms: [],
    EmailFlowBuilderAPIKey: {},
    ContactList: [],
    ContactBooks: [],
    EmailBroadcasts: [],
    LandingPages: [],
    EmailTemplates: [],
    OptinTemplates: [],

    //Instagram
    ActiveInstagram: {},
    instaAutoCommentConfig: {},

}
